namespace Solovis.Reports.ReportHelpers.ReportLibrary {

    export class ReportTreeListControl extends Solovis.UI.BaseControl {
        private _reportListDataSet;
        private _userHasReportEditPermission;

        private _treeItems;
        private _idToEntryMap;

        private _treeListInstance;

        private _lastWidth = 500;
        private _lastHeight = 300;

        constructor(options) {
            super(options);

            this._reportListDataSet = options.reportListDataSet;
            this._userHasReportEditPermission = options.userHasReportEditPermission;

            let rootNode = this._reportListDataSet.rootNode;

            let treeItems = [];

            let idToEntryMap = {};

            let addItemsForNode = (items, node) => {
                if (node.entryList) {
                    for (let entry of node.entryList) {
                        let item = {
                            text: entry.name,
                            entry: entry,
                            id: entry.nodeId
                        };                        

                        idToEntryMap[item.id] = entry;
                        items.push(item);
                    }
                }
                if (node.nodes) {
                    for (let childNode of node.nodes) {
                        let item = {
                            text: childNode.name,
                            items: [],
                            id: childNode.nodeId
                        };
                        items.push(item);
                        addItemsForNode(item.items, childNode);
                    }
                }
            };

            addItemsForNode(treeItems, rootNode);

            this._idToEntryMap = idToEntryMap;
            this._treeItems = treeItems;      
        }

        public doRender() {
            let treeListDiv = $("<div>").appendTo(this.container);
            this._treeListInstance = $(treeListDiv).dxTreeList({
                dataSource: this._treeItems,
                dataStructure: "tree",

                rowAlternationEnabled: true,

                width: this._lastWidth,
                height: this._lastHeight,   

                expandedRowKeys: this._getExpandedFolders(),

                onContextMenuPreparing: (e) => {
                    e.items = [];

                    e.items.push({
                        text: "Expansion Settings",

                        items: [
                            {
                                text: "Save Expanded Folders (Local Browser)",
                                onItemClick: () => {
                                    this._saveExpandedFolders();
                                }
                            },
                            {
                                text: "Reset Expanded Folders (Local Browser)",
                                onItemClick: () => {
                                    this._resetExpandedFolders();
                                }
                            }
                        ]
                    });
                },

                columns: [
                    {
                        caption: "Report",
                        dataField: "text",
                        width: 300,

                        cellTemplate: (cellElement, cellInfo) => {
                            let data = cellInfo.data;
                            let entry = data.entry;

                            if (entry) {
                                ReportLibraryReportGenerator._createReportDiv(entry.name, entry, this._userHasReportEditPermission).appendTo(cellElement);                                
                            }
                            else {
                                $("<span>").text(data.text).appendTo(cellElement);
                            }
                        }
                    }
                ]
            }).dxTreeList("instance");

            this.updateSpaceAvailable(this._lastWidth, this._lastHeight);
        }

        public updateSpaceAvailable(width, height) {
            this._lastWidth = width;
            this._lastHeight = height - 10;

            if (this._treeListInstance) {
                this._treeListInstance.option("width", this._lastWidth);
                this._treeListInstance.option("height", this._lastHeight);
            }
        }

        private _saveExpandedFolders() {
            let expandedReportLibraryKeys = this._treeListInstance.option("expandedRowKeys");

            window.localStorage.setItem("Solovis__expandedReportLibraryKeys", JSON.stringify(expandedReportLibraryKeys));
        }

        private _getExpandedFolders() {
            try {
                let expandedReportLibraryKeysJson = window.localStorage.getItem("Solovis__expandedReportLibraryKeys");
                if (expandedReportLibraryKeysJson) {
                    let expandedReportLibraryKeys = JSON.parse(expandedReportLibraryKeysJson);
                    return expandedReportLibraryKeys;
                }
            }
            catch (ex) {
            }

            // Default to expanding Solovis folder only.
            return ["folder---/Solovis"];
        }

        private _resetExpandedFolders() {
            window.localStorage.removeItem("Solovis__expandedReportLibraryKeys");

            this._treeListInstance.option("expandedRowKeys", this._getExpandedFolders());
        }
    }

}